import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import DateInput from "../../Components/Inputs/DateInput";
import EmailInput from "../../Components/Inputs/EmailInput";
import SelectInput from "../../Components/Inputs/SelectInput";
import ImageInput from "../../Components/Inputs/ImageInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import ReactDatepicker from "../../Components/Inputs/ReactDatepicker";

export default function ({ register, errors, control, data }) {
  return (
    <>
      <ImageInput
        name="avatar"
        parentClasses="col-md-12"
        classes="d-inline-block"
        register={register}
        control={control}
        errorMessage={errors?.avatar}
      />
      <TextInput
        label="First Name"
        name="first_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.first_name}
      />
      <TextInput
        label="Last Name"
        name="last_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.last_name}
      />
      <EmailInput
        label="Email"
        name="email"
        parentClasses="col-md-6"
        register={register}
        required={true}
        autoComplete="new-email"
        errorMessage={errors?.email}
      />
      <TextInput
        label="Phone"
        name="phone"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.phone}
      />
      <ReactDatepicker
        label="Birthday"
        name="birthday"
        placeholder="dd/mm/yyyy"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.birthday}
        control={control}
      />
      <TextInput
        label="Personal Number"
        name="personal_number"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.personal_number}
      />
      <ReactSelectInput
        label="Role"
        name="role_id"
        placeholder="Choose role"
        inputClassName="col-md-6"
        register={register}
        options={data?.roles}
        errorMessage={errors?.role_id}
        control={control}
      />
      <SelectInput
        label="Active"
        name="active"
        parentClasses="col-md-6"
        firstOption="Choose active status"
        options={["Yes", "No"]}
        register={register}
        disabled={true}
        errorMessage={errors?.active}
      />
    </>
  );
}